<template>
  <Card dis-hover class="rule-card">
    <template #title>
      <div class="rule-header">{{ $t('key1002177') }}</div>
    </template>
    <Form
      ref="actionParams"
      :model="actionParams"
      :rules="actionRule"
      :lable-width="80"
      :disabled="isDisabled"
      label-position="left">
      <FormItem :label="$t('key1005198')" prop="ruleName">
        <Input v-model.trim="actionParams.ruleName" clearable style="width:300px"></Input>
      </FormItem>
      <FormItem :label="$t('key1000930')" prop="type">
        <RadioGroup v-model="actionParams.type">
          <Radio :label="0">{{ $t('key1005201') }}</Radio>
          <Radio :label="1">{{ $t('key1005202') }}</Radio>
        </RadioGroup>
      </FormItem>
      <Card dis-hover class="ship-card-box" v-if="actionParams.type === 0">
        <Row>
          <Col :span="15">
            <Form-item :label="$t('key1005199')" :label-width="130">
              <Cascader
                v-if="ruleType === 'smartLogistics'"
                :data="shippingMethodData"
                @on-visible-change="showShippingDataApiMatch"
                v-model="value2"
                :load-data="loadDataApiMatch"
                @on-change="getAccountApiMatch">
              </Cascader>
              <template v-else>
                <Select filterable multiple :placeholder="$t('key1001359')" v-model="shippingMethodIds">
                  <OptionGroup v-for="(item,index) in logisticsModeData" :label="item.title" :key="index">
                    <Option v-for="(ele,idx) in item.list" :value="ele.ymsLogisServiceId" :key="idx">{{ ele.name }}</Option>
                  </OptionGroup>
                </Select>
              </template>
            </Form-item>
            <div v-if="logisticsDeactivateData.length >0 && ruleType !== 'smartLogistics'" class="redColor font-size-12">
              <p v-for="item in logisticsDeactivateData">
                {{ item.name + '、' }}
              </p>
              <span>{{ $t('key1005203') }}</span>
            </div>
          </Col>
          <Col :span="9" :offset="1" v-if="isOnlineShip === 0 && ruleType === 'smartLogistics'">
            <Form-item :label="$t('key1005200')" :label-width="60">
              <Select ref="shipAccount" v-model="shippingAccountModel" filterable>
                <Option
                  v-for="(item,index) in carrierAccount"
                  v-if="item.carrierAccountId !== null"
                  :key="index"
                  :value="item.carrierAccountId">{{ item.account }}
                </Option>
              </Select>
            </Form-item>
          </Col>
        </Row>
        <div class="matchLogisticSetting" v-if="carrierBaseSetting.length > 0">
          <h6>{{ $t('key1005204') }}</h6>
        </div>
        <Form :disabled="isDisabled" @submit.native.prevent>
          <Row class="white-space-nowrap-form">
            <Col :span="10" v-for="(item,index) in carrierBaseSetting" :key="index" class="offset-1">
              <Form-item
                v-if="item.paramType === 'hide'"
                v-show="false"
                :label="item.paramName"
                :label-width="100">
                <span>{{ item.paramValue }}</span>
              </Form-item>
              <Form-item v-else :label="item.paramName" :label-width="100">
                <Radio-group v-model="item.paramValue" v-if="item.paramType === 'radio'">
                  <Radio :label="sItem.itemValue" v-for="(sItem,n) in item.dictionarys" :key="n">
                    <span>{{ sItem.itemName }}</span>
                  </Radio>
                </Radio-group>
                <Input v-if="item.paramType === 'input'" v-model.trim="item.paramValue" clearable></Input>
                <Checkbox-group v-model="item.paramValue" v-if="item.paramType === 'checkbox'">
                  <Checkbox v-for="(sItem,n) in item.dictionarys" :key="n" :label="sItem.itemValue">
                    <span>{{ sItem.itemName }}</span>
                  </Checkbox>
                </Checkbox-group>
                <Select v-if="item.paramType === 'select'" v-model="item.paramValue" filterable>
                  <Option
                    v-for="(sItem,n) in item.dictionarys"
                    :key="n"
                    :value="sItem.itemValue"> {{ sItem.itemName }}
                  </Option>
                </Select>
                <span v-if="item.paramType === 'readOnly'">{{ item.paramValue }}</span>
              </Form-item>
            </Col>
          </Row>
        </Form>
        <div class="clear" v-if="ruleType === 'smartLogistics'">
          <Button size="small" class="fr" @click="saveShippingAccount">{{ $t('key1000555') }} </Button>
        </div>
        <!--保存的值-->
        <p class="mb10" v-if="ruleType === 'smartLogistics'">{{ $t('key1001123') }}</p>
        <Alert
          v-for="(item,index) in desigMethodActionBoList"
          :key="index"
          :type="activeShippingMethodData && activeShippingMethodData.shippingMethodId === item.shippingMethodId ? 'warning' :'success'">
          <span class="show-desig" @click="showDesig(item)">{{ item.text }}</span>
          <Icon @click="closeMt(index)" type="ios-close" size="18" v-if="!isDisabled" style="cursor: pointer;position: absolute;
    right: 5px;"/>
        </Alert>
      </Card>
      <div v-if="actionParams.type" style="margin-bottom:10px;display:flex;align-items: center">
        <Checkbox v-model="actionParams.timeSelected">
          <span style="marginLeft:10px;">{{ $t('key1005205') }}</span>
          <InputNumber
            size="small"
            :min="0"
            :disabled="!actionParams.timeSelected"
            v-model="actionParams.maxSelectedValue">
          </InputNumber>
        </Checkbox>
        <Select
          v-model="actionParams.timeTracknumberType"
          :disabled="!(actionParams.timeSelected && actionParams.tracknumberSelected)"
          style="width:70px;marginLeft:10px;"
          size="small">
          <Option :value="0">{{ $t('key1000188') }}</Option>
          <Option :value="1">{{ $t('key1000189') }}</Option>
        </Select>
        <Checkbox v-model="actionParams.tracknumberSelected" style="marginLeft:15px;">
          <span style="marginLeft:10px;">{{ $t('key1001521') }}</span>
        </Checkbox>
        <Select
          :disabled="!actionParams.tracknumberSelected"
          v-model="actionParams.tracknumberSelectedValue"
          style="width:70px"
          size="small">
          <Option :value="0">{{ $t('key1005206') }}</Option>
          <Option :value="1">{{ $t('key1005207') }}</Option>
        </Select>
      </div>
      <FormItem :label="$t('key1001522')" prop="status">
        <i-switch size="large" v-model="actionParams.status" :true-value="1" :false-value="0">
          <template #open>{{ $t('key1000462') }}</template>
          <template #close>{{ $t('key1002180') }}</template>
        </i-switch>
      </FormItem>
    </Form>
  </Card>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api';
import ruleMixin from '@/components/mixin/rule_mixin';
import {setConfigCharacters, getYunLogisticsAllData, _handleMultilingualFields, getQueryCarrierShippingName} from "@/utils/common";

export default {
  name: 'smartAction',
  mixins: [Mixin, ruleMixin],
  data() {
    const noEmpty = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005193')));
      } else {
        callback();
      }
    };
    return {
      actionParams: {
        status: 0,
        ruleName: null,
        type: 0,
        carrierId: null,
        shippingMethodId: null,
        timeSelected: false,
        maxSelectedValue: null,
        timeTracknumberType: 0,
        tracknumberSelected: false,
        tracknumberSelectedValue: 1,
        isSupended: 0,
        isRemind: 0,
        supendedOrderReason: null,
        shipmentRemindingReason: null,
        warehouseIds: null,
        matchOtherRulesSelected: true,
        warehouseIdList: [],
        onlyDistriHaveStockSelected: true,
        matchOtherRulesSelected2: true
      },
      isOnlineShip: 0,
      shippingMethodIds: [],
      activeShippingMethodData: {},
      desigMethodActionBoList: [], // 物流信息
      value2: [],
      carrierAccount: [],
      carrierBaseSetting: [],
      actionRule: {
        ruleName: [
          {
            validator: noEmpty,
            trigger: 'blur'
          }
        ]
      },
      logisticsModeData: [],
      logisticsDeactivateData: []
    };
  },
  props: {
    isDisabled: {
      type: Boolean
    },
    selectWareID: {
      type: String
    },
    ruleType: {
      type: String // 'smartLogistics','distributorSmart'
    },
  },
  methods: {
    getYunShip() {
      this.logisticsModeData = [];
      this.logisticsDeactivateData = [];
      // 自有物流
      const _getSelfOwnedLogistics = () => {
        return new Promise((resolve) => {
          let newList = [];
          this.axios.get(api.get_ymsCarrier_queryDistributorCarrier).then(response => {
            if (response.data.code === 0) {
              let data = response.data.datas || [];
              data.map((item) => {
                if (item.queryYmsCarrierShippingMethodBoList) {
                  item.queryYmsCarrierShippingMethodBoList.map((ele) => {
                    let carrierShippingMethodName = _handleMultilingualFields(ele.carrierShippingMethodName);
                    newList.push({
                      ...ele,
                      name: item.carrierName + ' / ' + carrierShippingMethodName,
                      ymsLogisServiceId: 'CID' + ele.shippingMethodId,
                      carrierMerchantType: 2
                    });
                  });
                }
              });
              let list = this.uniqueFunc(newList, 'ymsLogisServiceId');
              resolve(list);
            }
          });
        });
      };
      // 供应商物流
      const _getSupplierLogistics = () => {
        return new Promise((resolve) => {
          let newList = [];
          this.axios.get(api.get_ymsCarrierShippingMethod_api_querySupplierOwnCarriers).then(response => {
            if (response.data.code === 0) {
              let data = response.data.datas || [];
              data.map((item) => {
                if (item.carrierShippingMethods) {
                  item.carrierShippingMethods.map((ele) => {
                    let carrierShippingMethodName = _handleMultilingualFields(ele.carrierShippingMethodName);
                    newList.push({
                      ...ele,
                      name: item.carrierName + ' / ' + carrierShippingMethodName,
                      ymsLogisServiceId: 'CID' + ele.shippingMethodId,
                      carrierMerchantType: 1
                    });
                  });
                }
              });
              let list = this.uniqueFunc(newList, 'ymsLogisServiceId');
              resolve(list);
            }
          });
        });
      };
      Promise.all([getYunLogisticsAllData(), _getSelfOwnedLogistics(), _getSupplierLogistics()]).then((result) => {
        let cloudSalesLogisticsData = result[0] || [];
        let ownLogisticsData = result[1] || [];
        let supplierLogisticsData = result[2] || [];
        cloudSalesLogisticsData.map((item) => {
          item.carrierMerchantType = 3;
        });
        let ymsEnableData = cloudSalesLogisticsData.filter((item) => item.status === 1);
        let ymsDeactivateData = cloudSalesLogisticsData.filter((item) => item.status === 0);
        let ownLogisticsEnableData = ownLogisticsData.filter((item) => item.status === 1);
        let ownLogisticsDeactivateData = ownLogisticsData.filter((item) => item.status === 0);
        let supplierLogisticsEnableData = supplierLogisticsData.filter((item) => item.status === 1);
        let supplierLogisticsDeactivateData = supplierLogisticsData.filter((item) => item.status === 0);
        // 处理云卖物流、自有物流数据汇总
        this.logisticsModeData = [
          {title: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001581')}`, list: ymsEnableData},
          {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001587'), list: ownLogisticsEnableData},
          {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001666'), list: supplierLogisticsEnableData}
        ];
        // 停用的数据
        this.logisticsDeactivateData = [...ymsDeactivateData, ...ownLogisticsDeactivateData, ...supplierLogisticsDeactivateData];
      });
    },
    fixDataToView(details) {
      let v = this;
      if (details) {
        v.actionParams.ruleName = details.ruleName;
        v.actionParams.status = Number(details.status);
        v.processingActions(details.ruleActions);
      }
    },
    reset() {
      this.actionParams = {
        status: 0,
        ruleName: null,
        type: 0,
        carrierId: null,
        shippingMethodId: null,
        timeSelected: false,
        maxSelectedValue: null,
        timeTracknumberType: 0,
        tracknumberSelected: false,
        tracknumberSelectedValue: 1,
        isSupended: 0,
        isRemind: 0,
        supendedOrderReason: null,
        shipmentRemindingReason: null,
        warehouseIds: null,
        matchOtherRulesSelected: true,
        warehouseIdList: [],
        onlyDistriHaveStockSelected: true,
        matchOtherRulesSelected2: true
      };
      this.shippingMethodIds = [];
      this.desigMethodActionBoList = [];
    },
    processingActions(ruleActions) {
      let v = this;
      if (ruleActions !== null && ruleActions.length > 0) {
        for (let i = 0; i < ruleActions.length; i++) {
          let action = ruleActions[i];
          if (action.type === 'assignCarrier') {
            let data = JSON.parse(action.value);
            v.actionParams.type = data.type;
            if (!data.type) { // 0指定 1条件
              if (this.ruleType === 'distributorSmart') {
                v.shippingMethodIds = data.desigMethodActionBoList.map((item) => {
                  return item.id;
                });
              } else {
                v.$nextTick(() => {
                  if (data.desigMethodActionBoList) {
                    v.getShipName(data.desigMethodActionBoList).then(data => {
                      v.desigMethodActionBoList = data;
                    });
                  } else {
                    v.desigMethodActionBoList = [];
                  }
                });
                v.axios.get(api.get_enableShippingMethods + '?carrierId=' + data.carrierId + '&warehouseId=' + v.selectWareID).then(response => {
                  let data = response.data.datas;
                  let pos = [];
                  data.forEach((n, i) => {
                    pos.push({
                      value: n.shippingMethodId,
                      label: n.carrierShippingMethodName
                    });
                  });
                  v.shippingMethodList = pos;
                });
              }
            } else {
              if (data.timeSelected) {
                v.actionParams.timeSelected = true;
                v.actionParams.maxSelectedValue = data.maxSelectedValue;
              }
              if (data.tracknumberSelected) {
                v.actionParams.tracknumberSelected = true;
                v.actionParams.tracknumberSelectedValue = data.tracknumberSelectedValue;
              }
              v.actionParams.timeTracknumberType = data.timeTracknumberType;
            }
          } else if (action.type === 'supended') {
            v.actionParams.isSupended = Number(action.value);
          } else if (action.type === 'shipmentReminding') {
            v.actionParams.isRemind = Number(action.value);
          } else if (action.type === 'shipmentRemindingReason') {
            v.actionParams.shipmentRemindingReason = action.value;
          } else if (action.type === 'supendedOrderReason') {
            v.actionParams.supendedOrderReason = action.value;
          } else if (action.type === 'assignWarehouse') {
            let value = JSON.parse(action.value);
            v.actionParams.type = value.type;
            if (v.actionParams.type === 0) {
              v.actionParams.warehouseIds = value.warehouseIds;
            } else {
              v.actionParams.onlyDistriHaveStockSelected = value.onlyDistriHaveStockSelected !== 0;
              v.actionParams.matchOtherRulesSelected2 = value.matchOtherRulesSelected2 !== 0;
              v.actionParams.warehouseIdList = value.warehouseIds.split(',');
              let arr = [];
              v.listData = [];
              v.listSortDate = [];
              v.actionParams.warehouseIdList.forEach(i => {
                v.$store.state.warehouseList.forEach(j => {
                  if (i === j.warehouseId) {
                    arr.push(j);
                  }
                });
              });
              v.listData = arr;
              v.listSortDate = v.deepCopy(v.listData);
            }
            v.actionParams.matchOtherRulesSelected = value.matchOtherRulesSelected === 1;
          }
        }
      }
    },
    validMt() {
      let v = this;
      if (!v.actionParams.type) {
        if (this.ruleType === 'distributorSmart') {
          if (!(v.shippingMethodIds && v.shippingMethodIds.length)) {
            v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005194'));
            v.loading = false;
            return false;
          }
        } else if (this.ruleType === 'smartLogistics') {
          if (v.desigMethodActionBoList.length === 0) {
            v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005194'));
            v.loading = false;
            return false;
          }
        }
      } else {
        if (!v.actionParams.timeSelected && !v.actionParams.tracknumberSelected) {
          v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005195'));
          v.loading = false;
          return false;
        }
      }
      return true;
    },
    getShipName(data) {
      let v = this;
      return new Promise(resolve => {
        getQueryCarrierShippingName(data.map(i => {
          return i.shippingMethodId;
        })).then(response => {
          data.forEach((j, index) => {
            response.forEach(k => {
              if (j.shippingMethodId === k.shippingMethodId) {
                j.text = k.carrierName + '/' + k.carrierShippingMethodName;
              }
            });
          });
          resolve(data);
        });
      });
    },
    setParams() {
      let v = this;
      let value = {};
      if (!v.actionParams.type) { // 0指定物流  1条件物流
        let sVal;
        if (this.ruleType === 'distributorSmart') {
          let list = [];
          if (v.shippingMethodIds.length > 0) {
            v.shippingMethodIds.map((val) => {
              v.logisticsModeData.map((item) => {
                item.list.map((ele) => {
                  if (val === ele.ymsLogisServiceId) {
                    list.push({
                      id: val,
                      carrierMerchantType: ele.carrierMerchantType
                    });
                  }
                });
              });
            });
          }
          sVal = list;
        } else {
          sVal = v.desigMethodActionBoList;
        }
        value = {
          type: v.actionParams.type,
          desigMethodActionBoList: sVal
        };
      } else {
        value = {
          type: v.actionParams.type,
          timeSelected: v.actionParams.timeSelected ? 1 : 0,
          maxSelectedValue: v.actionParams.maxSelectedValue,
          timeTracknumberType: v.actionParams.timeTracknumberType,
          tracknumberSelected: v.actionParams.tracknumberSelected ? 1 : 0,
          tracknumberSelectedValue: v.actionParams.tracknumberSelectedValue
        };
      }
      return {
        ruleName: v.actionParams.ruleName,
        value: [
          {
            type: 'assignCarrier',
            value: JSON.stringify(value)
          }
        ],
        status: v.actionParams.status
      };
    },
    closeMt(index) {
      // 关闭事件
      this.desigMethodActionBoList.splice(index, 1);
    },
    saveShippingAccount() {
      // 点击新增
      let activeData = this.activeShippingMethodData; // 操作数据
      let shipIndex = null;
      if (activeData.shippingMethodId === '' || activeData.shippingMethodId === null) {
        this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005196'));
        return;
      }
      if ((this.shippingAccountModel === '' || this.shippingAccountModel === null) && this.isOnlineShip === 0) {
        this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005197'));
        return;
      }
      let obj = {
        carrierId: activeData.carrierId,
        shippingMethodId: activeData.shippingMethodId,
        carrierAccountId: this.shippingAccountModel,
        packageCarrierParamList: this.carrierBaseSetting,
        text: activeData.text
      };
      this.desigMethodActionBoList.forEach((i, index) => {
        if (i.shippingMethodId === activeData.shippingMethodId) {
          // 如果已经存在 就替换
          shipIndex = index;
        }
      });
      if (shipIndex !== null) {
        this.desigMethodActionBoList.splice(shipIndex, 1, obj);
      } else {
        this.desigMethodActionBoList.push(obj);
      }
      this.value2 = [];
      this.shippingAccountModel = '';
      this.carrierBaseSetting = [];
      if (this.$refs.shipAccount && this.$refs.shipAccount.reset) {
        this.$refs.shipAccount.reset();
      }
      this.activeShippingMethodData.shippingMethodId = null;
      this.activeShippingMethodData = null;
    },
    showDesig(item) {
      // 点击赋值
      this.showShippingDataApiMatch().then((data) => {
        setTimeout(() => {
          this.value2 = [item.carrierId, item.shippingMethodId];
        }, 0);
        data.forEach(i => {
          if (i.value === item.carrierId) {
            this.carrierAccount = i.carrierAccounts;
          }
        });
        this.carrierBaseSetting = item.packageCarrierParamList;
        this.activeShippingMethodData = JSON.parse(JSON.stringify(item)); // 存的值
        this.shippingAccountModel = item.carrierAccountId;
      });
      this.getCarrierBaseSettingApiMatch(item.shippingMethodId);
    },
    showShippingDataApiMatch(val) {
      // 没有仓库
      let v = this;
      return new Promise(resolve => {
        let warehouseType = v.$store.state.warehouseList.filter(i => {
          if (i.warehouseId === v.selectWareID) {
            return i;
          }
        })[0].warehouseType;
        v.axios.get(api.get_enableCarriers + '?warehouseId=' + v.selectWareID + '&isFilter=true' + '&warehouseType=' + warehouseType).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas || [];
            let pos = [];
            if (data.length > 0) {
              for (let i = 0; i < data.length; i++) {
                pos.push({
                  value: data[i].carrierId,
                  label: data[i].carrierName,
                  children: [],
                  loading: false,
                  carrierAccounts: data[i].carrierAccounts,
                  apiInterface: data[i].apiInterface
                });
                if (i === data.length - 1) {
                  v.shippingMethodData = pos;
                }
              }
              resolve(v.shippingMethodData);
            }
          }
        });
      });
    },
    loadDataApiMatch(item, callback) {
      // 没有仓库
      item.loading = true;
      let v = this;
      let hasShippingMethodId = v.desigMethodActionBoList ? v.desigMethodActionBoList.map(i => i.shippingMethodId) : [];
      v.axios.get(api.get_enableShippingMethods + '?carrierId=' + item.value + '&warehouseId=' + v.selectWareID).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          let pos = [];
          for (let i = 0; i < data.length; i++) {
            let obj = {
              value: data[i].shippingMethodId,
              label: data[i].carrierShippingMethodName
            };
            if (hasShippingMethodId.indexOf(data[i].shippingMethodId) > -1) {
              // 如果存在 让不可选
              // obj.disabled = true;
            }
            pos.push(obj);
            if (i === data.length - 1) {
              item.children = pos;
              item.loading = false;
              callback();
            }
          }
          if (data.length === 0) {
            item.children = pos;
            item.loading = false;
            v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000142'));
            callback();
          }
        } else {
          item.loading = false;
          item.children = [];
        }
      }).catch(() => {
        item.loading = false;
        item.children = [];
      });
    },
    getAccountApiMatch(value, selectedData) {
      // api.get_enableCarriersApi 太分散 未集中处理
      // 提取公共方法  此方法用于 /matchTheLogistics 物流方式 所有平台
      let v = this;
      v.carrierAccount = [];
      if (value.length === 0) return false;
      this.desigMethodActionBoList.some(i => {
        if (i.shippingMethodId === value[1]) {
          // 如果已经选择就把值带出来
          v.showDesig(i);
          return true;
        }
      });
      v.shippingMethodModel = [];
      v.shippingAccountModel = '';
      v.activeShippingMethodData = {
        carrierId: value[0],
        shippingMethodId: value[1],
        text: selectedData[0].label + '/' + selectedData[1].label
      }; // 用于存当前选中的
      v.apiInterfaceStatus = selectedData[0].apiInterface; // 存一下这个字段，当它为速卖通线上发货(API_AE_LG),eDIS物流(API_EDIS)的时候，不显示账号
      v.isOnlineShip = selectedData[0].isOnlineShip; // 存一下这个字段，当它为速卖通线上发货(API_AE_LG),eDIS物流(API_EDIS)的时候，不显示账号
      v.getCarrierBaseSettingApiMatch(value[1]);
      if (value[1] !== null) {
        v.carrierAccount = selectedData[0].carrierAccounts;
      }
    },
  }
};
</script>

<style scoped>
.ship-card-box .offset-1:nth-child(2n) {
  padding-left: 20px;
}

.clear {
  zoom: 1;
}

.fr {
  float: right;
}
</style>
<style>
.rule-card .ivu-card-head {
  background-color: #f7f7f7;
  height: 32px;
  padding: 0 0 0 10px;
  line-height: 32px;
}
</style>
